// Generated by purs version 0.15.0
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Photo = function (x) {
    return x;
};
var newtypePhoto_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqPhoto = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var genericPhoto = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPhoto = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPhoto)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Photo";
        }
    }))
};
var unscrambleDecodePhoto = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPhoto)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Unscramble.decodeString1)))(Unscramble_Generic.defaultOptions)
};
var encodePhoto = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPhoto)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))
};
var decodePhoto = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPhoto)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    Photo,
    genericPhoto,
    eqPhoto,
    showPhoto,
    encodePhoto,
    decodePhoto,
    unscrambleDecodePhoto,
    newtypePhoto_
};
//# sourceMappingURL=index.js.map
